const defaultSelectObject = { value: 0, label: 'Selecione' }
const defaultSelectArray = [{ ...defaultSelectObject }]

export { defaultSelectObject }
export default defaultSelectArray
